
import { Icon, Style } from "ol/style";
import studio from '../assets/pictos/Picto e-sport_Studio.svg'

const style = () => {

  return (
        new Style({
          image: new Icon({
            src: studio,
            scale:1
          })
      })
  )   
}

export default style;